import { api } from 'src/utils/api';

const listAllByAuthUser = () => api.get('/campaigns');

const create = params => api.post('/campaigns', params);

export { listAllByAuthUser, create };
